import React, { Component } from 'react';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import { getBranchesLatest } from '../../store/actions';
import withRouter from '../../components/lib/withRouter';
import { exportToExcel } from '../../utils/excelExport';

class BranchAnalysisReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            exams: [],
            selectedExam: null,
            selectedBranches: [],
            reportData: [],
            tableLoading: false,
        };

        this.service = new Service();
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true);
    }

    onBranchesChange = (selectedBranches) => {
        if (selectedBranches && selectedBranches.length > 0) {
            this.setState({
                selectedBranches,
                selectedExam: null,
                reportData: []
            }, () => {
                this.getBranchAnalysisReport();
            });
        }
    };

    getBranchAnalysisReport() {
        const { selectedBranches } = this.state;
        
        if (!selectedBranches || selectedBranches.length === 0) {
            return;
        }
    
        this.setState({ tableLoading: true });
    
        this.service
            .post(`${baseUrlAdmin}/academicsReports/branchAnalysisReport`, { 
                academicYear: localStorage.getItem('userAcademicYear'),
                branchIds: selectedBranches
            }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const rawData = response.res.data;

                    // Filter exams based on selected branches
                    const exams = [...new Map(
                        rawData
                            .filter(item => selectedBranches.includes(item.branchId))
                            .map(item => [item.examId, { examId: item.examId, examName: item.examName }])
                    ).values()];

                    // Batch state updates together
                    requestAnimationFrame(() => {
                        this.setState(prevState => ({
                            exams,
                            rawData,
                            selectedExam: null,
                            filteredData: [],
                            tableLoading: false,
                            dataTableKey: prevState.dataTableKey + 1
                        }));
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching exams:', error);
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch exams',
                    life: 3000
                });
            });
    }

    onExamChange = (selectedExam) => {
        this.setState({ selectedExam, reportData: [] });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam, selectedBranches } = this.state;
        if (!selectedBranches.length || !selectedExam) return;

        // Filter the rawData based on selected exam and branches
        const filteredData = rawData.filter(item => 
            item.examId === selectedExam.examId && 
            selectedBranches.includes(item.branchId)
        );

        this.setState({ reportData: filteredData });
    };

    render() {
        const { exams, selectedExam, selectedBranches, reportData, isLoading, tableLoading } = this.state;
        const { branchData } = this.props;

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '0',
                marginLeft: "100px",
                marginTop: "55px",
                overflow: 'auto',
            }}>
                <div className="card filters-card mt-1 pt-0">
                    <div className="flex">
                        {/* Branches MultiSelect */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Branches <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetMultiSelect
                                    value={selectedBranches}
                                    options={branchData}
                                    onChange={(e) => this.onBranchesChange(e.value)}
                                    optionLabel="name"
                                    optionValue="key"
                                    placeholder="Select Branches"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                />
                            </div>
                        </div>

                        {/* Exam Dropdown */}
                        <div className="col-4">
                            <p className="add-vehicle-field-label">
                                Exam <span style={{ color: 'red' }}>*</span>
                            </p>
                            <div className="flex justify-content-start align-items-center">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    placeholder="Select Exam"
                                    width={"25vw"}
                                    height={"48px"}
                                    style={{ border: '10px solid #E6E8EA' }}
                                    disabled={!selectedBranches.length}
                                />
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-2 order-1 ml-auto mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => {
                                    const exportColumns = [
                                        { field: 'branchName', header: 'Branch Name' },
                                        { field: 'totalStudents', header: 'Total Students' },
                                        { field: 'presentCount', header: 'Present Students' },
                                        { field: 'absentCount', header: 'Absent Students' },
                                        { field: 'highestMarks', header: 'Max Mark' },
                                        { field: 'lowestMarks', header: 'Min Mark' },
                                        { field: 'averageMarks', header: 'Avg Mark' },
                                        { field: 'marksRangeCount.range250To300', header: '250-300' },
                                        { field: 'marksRangeCount.range200To250', header: '200-250' },
                                        { field: 'marksRangeCount.range150To200', header: '150-200' },
                                        { field: 'marksRangeCount.range100To150', header: '100-150' },
                                        { field: 'marksRangeCount.range0To100', header: '0-100' },
                                        { field: 'marksRangeCount.lessThan0', header: '<0' }
                                    ];
                                    exportToExcel(reportData, 'Branch_Analysis_Report', exportColumns);
                                }}
                                disabled={!reportData.length}
                                className="p-button-secondary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam || !selectedBranches.length}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2' style={{ position: 'relative' }}>
                    {isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}>
                            <LoadingComponent />
                        </div>
                    )}
                    
                    <DataTable
                        value={reportData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                        responsiveLayout="scroll"
                        columnResizeMode="expand"
                        resizableColumns
                        className="p-datatable-custom"
                        loading={tableLoading}
                        loadingIcon="pi pi-spinner"
                        showLoader={false}
                    >
                        <Column field="branchName" header="Branch Name" />
                        <Column field="totalStudents" header="Total Students" />
                        <Column field="presentCount" header="Present Students" />
                        <Column field="absentCount" header="Absent Students" />
                        <Column field="highestMarks" header="Max Mark" />
                        <Column field="lowestMarks" header="Min Mark" />
                        <Column field="averageMarks" header="Avg Mark" />
                        <Column field="marksRangeCount.range250To300" header="250-300" />
                        <Column field="marksRangeCount.range200To250" header="200-250" />
                        <Column field="marksRangeCount.range150To200" header="150-200" />
                        <Column field="marksRangeCount.range100To150" header="100-150" />
                        <Column field="marksRangeCount.range0To100" header="0-100" />
                        <Column field="marksRangeCount.lessThan0" header="<0" />
                    </DataTable>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    branchData: (state.branchDataLatest?.data?.data.filter((each) => each.level === 1)) || [],
});

export default connect(mapStateToProps, { getBranchesLatest })(withRouter(BranchAnalysisReport));